import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-3">
            <div>
              <span className="text-xs text-foreground-400 tracking-wider uppercase">探索分类</span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2">
                丰富的漫画类型
              </h2>
            </div>
            <p className="text-sm text-foreground-500 max-w-sm">
              涵盖恋爱、动作、奇幻、悬疑等多种类型，满足您的不同阅读喜好
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {categories.map((cat, idx) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group relative rounded-lg overflow-hidden cursor-pointer h-52"
              >
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/25 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="w-6 h-6 flex items-center justify-center bg-primary-500/90 rounded-full">
                      <i className={`${cat.icon} text-xs text-white`}></i>
                    </span>
                    <h3 className="text-lg font-bold text-white">{cat.name}</h3>
                    <span className="text-xs text-white/70 ml-auto bg-white/20 px-2 py-0.5 rounded-full">
                      {cat.count}部
                    </span>
                  </div>
                  <p className="text-sm text-white/70">{cat.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}